
/**
 * 节点类型
 */
export const getNodeTypeList = () => {
  return [
    { libraryCode: 'root', libraryName: '根节点' },
    { libraryCode: 'company', libraryName: '公司' },
    { libraryCode: 'branch_company', libraryName: '分公司' },
    { libraryCode: 'department', libraryName: '部门' },
    { libraryCode: 'group', libraryName: '组' },
    { libraryCode: 'team', libraryName: '队' }
  ]
}

// 获取节点类型的下标
export const getNodeTypeByType = typeVal => {
  let typeIndex = 0
  const nodeTypeList = getNodeTypeList()
  try {
    nodeTypeList.forEach(item => {
      if (item.libraryCode === typeVal) {
        throw new Error('结束循环')
      } else {
        typeIndex = typeIndex + 1
      }
    })
  } catch (e) {

  }
  return { index: typeIndex, type: nodeTypeList[typeIndex] }
}

/**
 * 获取节点类型的下标
 */
export const getNodeTypeIndex = typeVal => {
  return getNodeTypeByType(typeVal).index
}





